/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect, useContext } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import Swal from "sweetalert2";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// NewEvent page components
import FormFields from "./components/FormFields";
import { addNewMediaImgsApi } from "api/medias";

import { useNavigate } from "react-router-dom";
import { getAllEventApi } from "api/events";
import { addNewReservationApi, sendNewReservationEmailApi } from "api/tickets";
import { CircularProgress } from "@mui/material";
import { getAllEventTitleApi } from "api/events";
import { AuthContext } from "context/authContext";
import { getCookie } from "utils/cookies";
const initialFormState = {
  formInfo: {
    fromEvent: "",
    ticketType: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    couponCode: "",
    availableCategories: [],
    selectedCategory: "",

    availableCouponCode: [],
    selectedCouponCode: "",

    selectedCategoryPrice: 0,
    numberOfTickets: 0,
    pricing: [],
    sumOfPrice: 0,
    isSelectetivePlaces: false,
    seatIoId: "",
    buyFromType: 'offline',
  },
  seatInfo: [],
};

function NewReservation() {
  const { userRole } = useContext(AuthContext);

  const navigate = useNavigate();

  useEffect(() => {
    getInitialData();
  }, []);

  const [eventData, setEventData] = useState([]);
  const [formValue, setFormValue] = useState(initialFormState);
  const [isLoading, setIsLoading] = useState(false);

  const getInitialData = async () => {
    try {
      const eventResponse = await getAllEventTitleApi();
      const eventDataArray = eventResponse.map((el) => ({
        title: el.eventTitle,
        id: el._id,
        eventSiege: el.eventSiege,
        isSelectetivePlaces: el.isSelectetivePlaces,
        seatIoId: el.seatIoId,
        eventDateList: el.eventDateList,
        selectedTimeId: el.selectedTimeId,
        isCinema: el.isCinema,
        isCirque: el.isCirque,
      }));
      setEventData(eventDataArray);
    } catch (err) {
      console.log(err);
    }
  };

  const handleGetFormValues = (value) => {
    try {
      setFormValue((prevFormValue) => ({
        ...prevFormValue,
        formInfo: value,
      }));
    } catch (err) {
      console.log(err);
    }
  };
  const handleGetSelectedPlaceEvent = (value) => {
    try {
      setFormValue((prevFormValue) => ({
        ...prevFormValue,
        seatInfo: value,
      }));
    } catch (err) {
      console.log(err);
    }
  };

  const handleAddNewTickets = async () => {
    try {
      const totalSum = parseFloat(formValue?.formInfo?.sumOfPrice || 0);
      const formattedTotalSum = totalSum.toFixed(2);
      const selectedCategoriesFromSeat = [];

      const objectFormValues = {
        fromEvent: formValue?.formInfo?.fromEvent,
        ticketType: formValue?.formInfo?.ticketType,
        firstName: formValue?.formInfo?.firstName,
        lastName: formValue?.formInfo?.lastName,
        email: formValue?.formInfo?.email,
        phone: formValue?.formInfo?.phone,
        couponCode: formValue?.formInfo?.couponCode,
        selectedCategory: formValue?.formInfo?.selectedCategory,
        numberOfTickets: formValue?.formInfo?.numberOfTickets,
        selectedPlaces: [],
        buyFrom: {
          online: formValue?.formInfo?.buyFromType === "online",
          offline: formValue?.formInfo?.buyFromType === "offline",
        },
        isCinema: formValue?.formInfo?.isCinema || false,
        isCirque: formValue?.formInfo?.isCirque || false,
        selectedTimeId: formValue?.formInfo?.selectedTimeId || "",

        isCreatedBy: {
          superAdmin: userRole === "SuperAdmin" ? getCookie("3F2Mb2pJ1YRro5Z4") : null,
          producer: userRole === "Producer" ? getCookie("3F2Mb2pJ1YRro5Z4") : null,
          reseller: userRole === "Revendeur" ? getCookie("3F2Mb2pJ1YRro5Z4") : null,
        }
      };

      if (!objectFormValues.fromEvent || objectFormValues.fromEvent === "") {
        return Swal.fire({
          title: "Erreur",
          text: "Veuillez sélectionner l'événement.",
          icon: "error",
        });
      }
      if (!objectFormValues.ticketType || objectFormValues.ticketType === "") {
        return Swal.fire({
          title: "Erreur",
          text: "Veuillez sélectionner ticket ou invitation.",
          icon: "error",
        });
      }
      if (!objectFormValues.firstName || objectFormValues.firstName === "") {
        return Swal.fire({ title: "Erreur", text: "Veuillez saisir votre prénom.", icon: "error" });
      }
      if (!objectFormValues.lastName || objectFormValues.lastName === "") {
        return Swal.fire({ title: "Erreur", text: "Veuillez saisir votre nom.", icon: "error" });
      }
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!objectFormValues.email || !emailRegex.test(objectFormValues.email.trim())) {
        return Swal.fire({
          title: "Erreur",
          text: "Veuillez saisir une adresse e-mail valide.",
          icon: "error",
        });
      }
      if((objectFormValues.isCinema || objectFormValues.isCirque) && (!objectFormValues.selectedTimeId || objectFormValues.selectedTimeId === "")) {
        return Swal.fire({
          title: "Erreur",
          text: "Veuillez sélectionner un horaire.",
          icon: "error",
        });
      }

      if (formValue?.formInfo?.isSelectetivePlaces) {
        formValue?.seatInfo.map((el) => {
          selectedCategoriesFromSeat.push(el?.category?.label);
          objectFormValues.selectedPlaces.push(el.id);
        });

        if (!objectFormValues.selectedPlaces || objectFormValues.selectedPlaces.length === 0) {
          return Swal.fire({
            title: "Erreur de sélection de place",
            text: "Veuillez sélectionner des places sur le plan.",
            icon: "error",
          });
        }

        const uniqueSelectedCategoriesFromSeat = [...new Set(selectedCategoriesFromSeat)];
        if (uniqueSelectedCategoriesFromSeat.length > 1) {
          return Swal.fire({
            title: "Erreur de catégorie",
            text: "Veuillez sélectionner des places d'une seule catégorie.",
            icon: "error",
          });
        }

        const selectedCategory = formValue?.formInfo?.availableCategories.find(
          (el) => el.name === uniqueSelectedCategoriesFromSeat[0]
        );

        if (selectedCategory) {
          objectFormValues.selectedCategory = selectedCategory.id;
          objectFormValues.numberOfTickets = objectFormValues.selectedPlaces.length;
          objectFormValues.price = parseFloat(selectedCategory.price);
        } else {
          return Swal.fire({
            title: "Erreur de catégorie",
            text: "Impossible de trouver les détails de la catégorie sélectionnée pour les places.",
            icon: "error",
          });
        }
      } else {
        if (!objectFormValues.selectedCategory) {
          return Swal.fire({
            title: "Erreur de catégorie",
            text: "Veuillez sélectionner une catégorie de ticket.",
            icon: "error",
          });
        }
        if (!objectFormValues.numberOfTickets || parseInt(objectFormValues.numberOfTickets) <= 0) {
          return Swal.fire({
            title: "Erreur de nombre de tickets",
            text: "Veuillez spécifier le nombre de tickets.",
            icon: "error",
          });
        }
        const selectedCategory = formValue?.formInfo?.availableCategories.find(
          (el) => el.id === objectFormValues.selectedCategory
        );
        if (selectedCategory) {
          objectFormValues.price = parseFloat(selectedCategory.price);
        } else {
          return Swal.fire({
            title: "Erreur de catégorie",
            text: "Les détails de la catégorie sélectionnée ne sont pas disponibles pour calculer le prix.",
            icon: "error",
          });
        }
      }

      const sendOptionResult = await Swal.fire({
        title: "Choisir le mode d'envoi",
        html: `
        Comment souhaitez-vous finaliser la réservation ?<br><br>
        <strong>Email:</strong> <span style="color: #28a745; font-weight: bold;">${objectFormValues.email}</span><br>
                <strong>Nombre de tickets:</strong> <span style="color: #28a745; font-weight: bold;">${objectFormValues.numberOfTickets}</span><br> 

        <strong>Prix total:</strong> <span style="color: #28a745; font-weight: bold; font-size: 1.1em;">${formattedTotalSum} MAD</span>
      `,
        icon: "question",
        showCancelButton: true,
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: "Envoyer les tickets par email",
        denyButtonText: "Ajouter la réservation seulement",
        cancelButtonText: "Annuler",
        allowOutsideClick: false,
        reverseButtons: false,
        confirmButtonColor: "#007bff",
        denyButtonColor: "#007bff",
        cancelButtonColor: "#007bff",
      });
      if (sendOptionResult.isConfirmed || sendOptionResult.isDenied) {
        setIsLoading(true);
        try {
          const reservationResponse = await addNewReservationApi(objectFormValues);
          if (
            !reservationResponse ||
            !reservationResponse.commandeDetails ||
            !reservationResponse.tickets
          ) {
            throw new Error(
              `Invalid response from reservation creation API: ${
                reservationResponse?.message || "Unknown error"
              }`
            );
          }

          let finalSuccessMessage = "Réservation ajoutée avec succès.";

          const initialFormState = {
            formInfo: {
              fromEvent: "",
              ticketType: "",
              firstName: "",
              lastName: "",
              email: "",
              phone: "",
              couponCode: "",
              availableCategories: [],
              selectedCategory: "",
              selectedCategoryPrice: 0,
              numberOfTickets: 0,
              pricing: [],
              sumOfPrice: 0,
              isSelectetivePlaces: false,
              seatIoId: "",
              buyFromType: "offline",
            },
            seatInfo: [],
          };
          setFormValue(initialFormState);

          if (sendOptionResult.isConfirmed) {
            try {
              await sendNewReservationEmailApi(
                reservationResponse.commandeDetails,
                reservationResponse.tickets,
                objectFormValues.email
              );
              finalSuccessMessage = "Réservation ajoutée et tickets envoyés par email avec succès.";
            } catch (emailError) {
              Swal.fire({
                title: "Réservation ajoutée, mais l'envoi de l'email a échoué.",
                text: emailError?.response?.data?.error || emailError.message,
                icon: "warning",
              });
            }
          }

          Swal.fire({
            title: "Succès!",
            text: finalSuccessMessage,
            icon: "success",
          }).then(() => {
            navigate(`/reservations/reservations`);
          });
        } catch (err) {
          setIsLoading(false);
          // let errorText = err?.message || "Erreur inconnue.";
          // if (err?.response?.data?.seatIoError) errorText = err.response.data.seatIoError;
          Swal.fire({
            title: "Erreur",
            text: err.response.data.error,
            icon: "error",
          });
        } finally {
          setIsLoading(false);
        }
      }
      else if (sendOptionResult.dismiss === Swal.DismissReason.cancel) {
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Erreur générale:", error);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox my={3}>
        <MDBox>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} lg={6}>
              <MDTypography variant="h4" fontWeight="medium">
                Ajouter une réservation
              </MDTypography>
              <MDBox mt={1} mb={2}>
                <MDTypography variant="body2" color="text"></MDTypography>
              </MDBox>
            </Grid>
            {/* <Grid item xs={12} lg={6}>
              <MDBox display="flex" justifyContent="flex-end">
                {
                  isLoading ?
                  <MDBox>
                    <CircularProgress size={40} color="info"></CircularProgress>
                  </MDBox> :
                  <MDButton variant="gradient" color="info" onClick={handleAddNewTickets}>
                    Ajouter
                  </MDButton>
                }
              </MDBox> 
            </Grid> */}
          </Grid>
        </MDBox>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormFields
              formValues={handleGetFormValues}
              eventData={eventData}
              selectedPlaceEvent={handleGetSelectedPlaceEvent}
              currentFormValues={formValue}
              actionButton={
                <Grid item xs={12} lg={6}>
                  <MDBox mb={2}>
                    {isLoading ? (
                      <MDBox>
                        <CircularProgress size={40} color="info" />
                      </MDBox>
                    ) : (
                      <MDButton variant="gradient" color="info" onClick={handleAddNewTickets}>
                        Ajouter
                      </MDButton>
                    )}
                  </MDBox>
                </Grid>
              }
            />
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default NewReservation;
